<template>
  <v-dialog v-model="dialog" width="800px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Dish.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="KeyWord = $event"
              :label="$t('MiniProgramSettings.Fields.food_relations_name')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="foods"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              foods.find((detail) => detail.choose != chooseAll) ? true : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.food="{ item }">
          {{
            $t("MiniProgramSettings.Fields.food_description", [
              item.food.food_code,
              item.food.food_name,
            ])
          }}
        </template>
        <template v-slot:item.food_relations="{ item }">
          {{
            $t("MiniProgramSettings.Fields.food_relations_description", [
              item.food_formula.formula_name,
              item.food_behavior.behavior_name,
            ])
          }}
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import FoodRelations from "@/api/food_relations";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    foodIds: Array,
    disabledIds: Array,
  },

  components: {
    SearcherKeyword,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("MiniProgramSettings.Fields.food"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "food",
        },
        {
          text: i18n.t("MiniProgramSettings.Fields.food_relations"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "food_relations",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    foods: [],
    materialKeyword: "",
    itemsPerPageOptions: 10,
    foodIdsChoosed: [],
    foodIdsDisabled: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    fetchTimestamp: 0, //第一次获取商品列表的时间
    options: { keyword: "" },
    KeyWord: "",
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.KeyWord,
      });
    },

    //获取material列表
    getFoodsFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.foods = this.foods.map((food) => {
          if (
            this.foodIdsChoosed.indexOf(food.id) > -1 &&
            (!food.choose || !food.disabled)
          ) {
            food = Object.assign({}, food, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.foodIdsChoosed.indexOf(food.id) == -1 &&
            (food.choose == 1 || food.disabled)
          ) {
            if (food.choose == 1) {
              food.choose = 0;
            }
            if (food.disabled) {
              food.disabled = false;
            }
          }
          if (this.foodIdsDisabled.indexOf(food.id) > -1) {
            food.disabled = true;
          }

          return food;
        });

        return;
      }
      FoodRelations.fetch({ limit: this.$consts.limitAll }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.foods = response.data.food_relations.map((food) => {
              //默认勾选
              if (this.foodIdsChoosed.indexOf(food.id) > -1) {
                food = Object.assign({}, food, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (food.choose == 1 || !food.choose) {
                  food.choose = 0;
                }
                if (food.disabled) {
                  food.disabled = false;
                }
              }
              if (this.foodIdsDisabled.indexOf(food.id) > -1) {
                food.disabled = true;
              }
              return food;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
    searchFoodsFromAPI() {
      FoodRelations.fetch(
        Object.assign({}, this.options, { limit: this.$consts.limitAll })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.foods = response.data.food_relations.map((food) => {
              //默认勾选
              if (this.foodIdsChoosed.indexOf(food.id) > -1) {
                food = Object.assign({}, food, {
                  choose: 1,
                  disabled: true,
                });
              } else if (
                this.newChoosedArr.find(
                  (new_choosed) => new_choosed.id == food.id
                )
              ) {
                food = Object.assign({}, food, {
                  choose: 1,
                });
              } else {
                if (food.choose == 1 || !food.choose) {
                  food.choose = 0;
                }
                if (food.disabled) {
                  food.disabled = false;
                }
              }
              if (this.foodIdsDisabled.indexOf(food.id) > -1) {
                food.disabled = true;
              }

              return food;
            });
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.searchFoodsFromAPI();
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          if (this.foodIds && this.foodIds.length) {
            this.foodIdsChoosed = JSON.parse(JSON.stringify(this.foodIds));
          } else {
            this.foodIdsChoosed = [];
          }
          if (this.disabledIds && this.disabledIds.length) {
            this.foodIdsDisabled = JSON.parse(JSON.stringify(this.disabledIds));
          }

          this.choosedLength = this.foodIdsChoosed.length;
          this.getFoodsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.Keyword = "";
          this.options = { keyword: "" };
          this.chooseAll = false;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.foods = this.foods.map(
          function (e) {
            var item = this.foods.find((m) => m.id == e.id && !e.disabled);
            if (item) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    foods: {
      deep: true,
      handler() {
        //整理新增商品
        this.foods.forEach((food) => {
          if (
            food.choose &&
            !this.foodIdsChoosed.includes(food.id) &&
            !this.newChoosedArr.find((new_choosed) => new_choosed.id == food.id)
          ) {
            this.newChoosedArr.push(food);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !food.choose &&
            this.newChoosedArr.find((new_choosed) => new_choosed.id == food.id)
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) => new_choosed.id == food.id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
  },
};
</script>